import { createFileRoute, Outlet, redirect, useMatchRoute } from '@tanstack/react-router'
import { hasTokens } from '../lib/auth'
import { useMe } from '../hooks/useAuth'
import { ScdBoard } from '../components/scd/ScdBoard'
import { ScdKpiWidget } from '../components/scd/ScdKpiWidget'

export const Route = createFileRoute('/scd-board')({
  beforeLoad: () => {
    if (!hasTokens()) {
      throw redirect({ to: '/login' })
    }
  },
  component: ScdBoardPage,
})

function ScdBoardPage() {
  const { data: me, isLoading } = useMe()
  const matchRoute = useMatchRoute()
  const onChild = matchRoute({ to: '/scd-board/$id', fuzzy: true })

  if (onChild) return <Outlet />

  if (isLoading || !me) {
    return (
      <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af' }}>
        Caricamento…
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div
        style={{
          padding: '14px 20px',
          borderBottom: '1px solid #e5e7eb',
          background: '#fff',
          display: 'flex',
          alignItems: 'baseline',
          gap: 10,
        }}
      >
        <h1 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>SCD Fattibilità</h1>
        <span style={{ fontSize: 13, color: '#9ca3af' }}>pipeline interna</span>
      </div>
      <ScdKpiWidget />
      <div style={{ flex: 1, overflow: 'hidden' }}>
        <ScdBoard me={me} />
      </div>
    </div>
  )
}
